import angular from 'angular';
import Roblox from 'Roblox';
import registerDirectives from './directives/registerDirectives';

// Custom translation filter since we're advice to not build any new features in Angular
// https://roblox.atlassian.net/wiki/spaces/WFG/pages/1589543934/Using+Translation+Resources
// Crowdin is working on Syncs: https://github.rbx.com/Roblox/crowdin-synchronization/actions/runs/7523521
// And we are unable to choose "web" on new enforce translation hub:
// https://translations-hub.simulprod.com/translatable-content
function translateOrDefaultFilter($filter) {
  return function (input, defaultValue) {
    try {
      var translation = $filter('translate')(input);
      const isTranslationValid = String(translation).trim().length > 0;
      return isTranslationValid ? translation : defaultValue;
    } catch (error) {
      console.error("[filter('translate')] Translation error for key:", input, error);
      return defaultValue;
    }
  };
}

const support = angular
  .module('support', ['supportHtmlTemplateApp', 'robloxApp', 'ui.bootstrap', 'thumbnails', 'modal', 'captchaV2'])
  .config([
    'languageResourceProvider',
    function (languageResourceProvider) {
      const translationProvider = new Roblox.TranslationResourceProvider();
      const supportResources = translationProvider.getTranslationResource('Feature.Support');
      const commonUIControlResources = translationProvider.getTranslationResource('CommonUI.Controls');
      const commonUIAlertOptionsResources = translationProvider.getTranslationResource('Common.AlertsAndOptions');
      languageResourceProvider.setTranslationResources([commonUIControlResources, commonUIAlertOptionsResources, supportResources]);
    }
  ])
  .filter('translateOrDefault', ['$filter', translateOrDefaultFilter]);

registerDirectives(support);

export default support;
